import React from "react";

const ImageCredits = ({ credits }) => (
  <div className="text-center py-6 border-t border-gray-700 mt-10">
    {/* Updated header to be more general */}
    <p className="text-sm font-semibold text-gray-400 mb-2">Image Credits & Sources</p>
    <div className="text-xs text-gray-500 flex flex-wrap justify-center space-x-4">
      {credits.map((credit, index) => {
        // Check if the photographer entry starts with "AI Generated"
        const isAI = credit.photographer.startsWith('AI Generated');

        return (
          <span key={index} className="whitespace-nowrap mb-1">
            {credit.description}:
            {isAI ? (
              // Display AI Source
              <span className="text-gray-400 mx-0.5">
                Source: {credit.photographer}
              </span>
            ) : (
              // Display Standard Photo Credit (e.g., Unsplash)
              <>
                Photo by 
                <a href={credit.profileUrl} target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300 mx-0.5">
                  {credit.photographer}
                </a> 
                on <a href="https://unsplash.com" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300">Unsplash</a>
              </>
            )}
          </span>
        );
      })}
    </div>
  </div>
);


export default ImageCredits